module.exports = __webpack_public_path__ + "img/robot_gif1.5d281fbc.5d281fbc.gif";